<template>
    <slot name="main">
        
        <!-- Begin Page Content -->
        <router-view></router-view>
        <!-- End of Main Content -->
        
        <Loading />
        <AlertDialog />
        <ConfirmDialog />
    </slot>
</template>

<script>

import Loading from '@/components/loading.vue'
import AlertDialog from '@/components/dialog/alert.vue'
import ConfirmDialog from '@/components/dialog/confirm.vue'

export default {
    components: {
        Loading,
        AlertDialog,
        ConfirmDialog
    },
    data: function() {
        return {

        }
    },
    methods: {
        init: function() {

        },
    },
    mounted() {
        this.init();
    }
}
</script>
